import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { cn } from '@/utils/cn';
import { toPersianNumber } from '@/utils/persianNumber';
import { useCollections } from '../hooks/useCollections';

const COLLECTION_COLORS = [
    'bg-[#F8C8B8]',
    'bg-[#BFD7F2]',
    'bg-[#F3C4D2]',
    'bg-[#C7E8D2]',
    'bg-[#D9C8F2]',
    'bg-[#BFE7E1]',
];

const LearningPackageRow = () => {
    const navigate = useNavigate();
    const { data: collections, isLoading } = useCollections();

    if (isLoading) return null;
    if (!collections || collections.length === 0) return null;

    return (
        <section className="-mt-2 pb-4">
            <div className="flex items-center justify-between px-4 mb-4">
                <h2 className="font-persian font-bold text-sm sm:text-base text-right">مجموعه های منتخب</h2>
            </div>

            <div className="flex flex-col items-center gap-3 px-4 pb-2">
                {collections.map((collection, index) => {
                    const bgColor = COLLECTION_COLORS[index % COLLECTION_COLORS.length];
                    return (
                        <motion.div
                            key={collection.id}
                            onClick={() => navigate(`/library/collection/${collection.id}`, {
                                state: { collectionColor: bgColor },
                            })}
                            className={cn(
                                "w-full max-w-[340px] min-h-[116px] rounded-2xl p-0 relative flex items-center overflow-hidden cursor-pointer transition-transform hover:scale-[1.02] shadow-[0_4px_16px_rgba(15,23,42,0.12)]",
                                bgColor
                            )}
                            whileTap={{ scale: 0.98 }}
                        >
                            {/* Icon fills the left side and follows the card's real height */}
                            <img
                                src={collection.icon}
                                alt=""
                                className="absolute left-0 right-auto top-0 w-[104px] h-full object-cover"
                            />

                            <div className="relative z-10 w-full text-right py-3 pr-4 pl-[7rem]">
                                <div className="flex items-center">
                                    {/* Title */}
                                    <h3 className="text-gray-800 font-bold font-persian text-base leading-snug">
                                        {toPersianNumber(collection.name)}
                                    </h3>
                                </div>
                            </div>
                        </motion.div>
                    );
                })}
            </div>
        </section>
    );
};

export default LearningPackageRow;
